import { Paper } from "@mui/material";
import React, { useState } from "react";
import AccountsWidget from "./AccountsWidget";
import Transactions from "./Transactions";

const Accounts = ({ supplier }) => {
  const [reloadKey, setReloadKey] = useState(0);

  return (
    <Paper className="p-[15px]">
      <div>
        <AccountsWidget {...{ supplier, setReloadKey }} />
      </div>

      <div className="mt-[15px]">
        <Transactions supplier={supplier} key={reloadKey} />
      </div>
    </Paper>
  );
};

export default Accounts;
